export default __webpack_public_path__ + "static/media/product-16 (2).ac568c7d.jpg";